// extracted by mini-css-extract-plugin
export default {"image":"ImageWithFallback_image__OMDud","fallback":"ImageWithFallback_fallback__vzZjU","mark":"ImageWithFallback_mark__H91Gf"};